
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface UploadResponse {
  mainImage?: string;
  additionalImages?: string[];
}

export function useBagImageUpload() {
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const uploadImages = async (
    styleNumber: number,
    mainImage?: File,
    additionalImages?: File[]
  ) => {
    setIsUploading(true);
    setError(null);

    try {
      const formData = new FormData();
      formData.append('styleNumber', styleNumber.toString());

      if (mainImage) {
        formData.append('mainImage', mainImage);
      }

      if (additionalImages) {
        additionalImages.forEach(image => {
          formData.append('additionalImages', image);
        });
      }

      const response = await supabase.functions.invoke<UploadResponse>('upload-bag-images', {
        body: formData,
      });

      if (response.error) {
        throw new Error(response.error.message);
      }

      return response.data;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred while uploading images');
      throw err;
    } finally {
      setIsUploading(false);
    }
  };

  return {
    uploadImages,
    isUploading,
    error,
  };
}
